import { render, staticRenderFns } from "./WebApplicationAdapter.vue?vue&type=template&id=be24f186&scoped=true&"
import script from "./WebApplicationAdapter.vue?vue&type=script&lang=ts&"
export * from "./WebApplicationAdapter.vue?vue&type=script&lang=ts&"
import style0 from "./WebApplicationAdapter.vue?vue&type=style&index=0&id=be24f186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be24f186",
  null
  
)

export default component.exports